import { render, staticRenderFns } from "./UpdatePasswordOverlay.vue?vue&type=template&id=3564ccb0&scoped=true"
import script from "./UpdatePasswordOverlay.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordOverlay.vue?vue&type=script&lang=js"
import style0 from "./UpdatePasswordOverlay.vue?vue&type=style&index=0&id=3564ccb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564ccb0",
  null
  
)

export default component.exports